<template>
  <main class="account-profile container-fluid mt-3 bg-white">
    <div class="row h-100 no-gutters pt-5">
      <div class="col-12 mx-lg-auto">
        <div
          class="row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
        >
          <div class="col-12 col-xl-2 col-md-3 pt-lg-6 border-right">
            <pc-side-nav/>
          </div>

          <div class="col-12 col-lg mb-3 mb-lg-5 pt-6">
            <section id="salesrep-section" class="mb-5 container-fluid">
              <div id="salesrep-heading" class="d-flex mb-4 pb-1 border-bottom">
                <p class="font-weight-normal text-uppercase">
                  {{ $resourceString["account.AccountSupport.Rep.Label"] }}
                </p>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    <b>
                      {{
                        $resourceString["account.AccountSupport.SalesRep.Label"]
                      }}
                    </b>
                    <br />
                    {{ salesrep? salesrep.firstName :"" }} {{salesrep? salesrep.lastName  :""}}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>
                      {{
                        $resourceString["account.AccountSupport.Contact.Label"]
                      }}
                    </b>
                    <br />
                    <a
                      :href="
                        'tel:+1' +
                          (salesrep?salesrep.phone == null
                            ? salesrep.mobilePhone
                            : salesrep.phone :'')
                      "
                    >
                      +1
                      {{
                       salesrep ? salesrep.phone == null
                          ? salesrep.mobilePhone
                          : salesrep.phone :""
                      }}
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PcSideNav from "../my-trays-page/pc-side-nav.vue";

export default {
  props: ["salesrep"],
  data() {
    return {
      editUrl: "Account/EditProfile?returnUrl=Account",
      resetPassword: "Account/ResetPassword?returnUrl=Account"
    };
  },
  components: {
    PcSideNav
  }
};
</script>
